import ApiService from "./ApiService";

export async function apiPutAdminToken(data) {
  return ApiService.fetchData({
    url: "/admin/token/update",
    method: "put",
    data,
  });
}
